import { render } from "./base_layout.vue?vue&type=template&id=e6f64234&scoped=true"
import script from "./base_layout.vue?vue&type=script&lang=js"
export * from "./base_layout.vue?vue&type=script&lang=js"

import "./base_layout.vue?vue&type=style&index=0&id=e6f64234&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f64234"]])

export default __exports__